import React from "react";

const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="current" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9158 20.5999V13.0279H14.1404L14.4735 10.0769H11.9158V8.19281C11.9158 7.33845 12.1235 6.75617 13.1959 6.75617L14.5636 6.75544V4.11615C14.327 4.08032 13.5151 4 12.5706 4C10.5986 4 9.24858 5.37516 9.24858 7.9007V10.077H7.01819V13.0279H9.24851V20.6L11.9158 20.5999Z" />
  </svg>
);

export default FacebookIcon;
